var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

ready(() => {
    // Get the current selected option
    function as_currentOption(select){
        const i = select.selectedIndex;
        const element = select.options[i];
        return element;
    }

    // For numeric selects, get the max length of digits needed from the select options
	function getNeededDigits(select){
        const options = select.querySelectorAll('option');
        let digits = 0;
        let maxDigits = 0;
        for(let i = 0; i < options.length; i++) {
            let el = options[i];
            digits = el.value.length;

            if(digits > maxDigits){
                maxDigits = digits;
            }
        };
        return maxDigits;
	}

    // Function for animating numeric options
	function animateOptions(option, value){
		const track = option.querySelector('.options-inner');
		// Unset the previously active value and add active state to new option value
        let active = option.querySelector('.active');
        if(active !== null){
            active.classList.remove('active');
        }

		active = option.querySelector('.option[data-value="'+value+'"]');
		active.classList.add('active');

		// get the pixel value of the active value offset, then convert that to a percentage for fluid styling.
		const activeTopPixel = Math.round(active.offsetTop - track.offsetTop);
		const trackHeight = Math.round(option.querySelector('.options-inner').offsetHeight);
		const posTop = (activeTopPixel / trackHeight) * 100;
		track.style.transform = 'translate(0,-'+posTop+'%)';
	}

    // For String select option values, get the values and insert them into the markup, then set the active item.
	function getStringOptions(select, currentOption){
        const optionsWrap = select.nextElementSibling.querySelector('.options-wrap');

        let elements = select.querySelectorAll('option');
        for(let i = 0; i < elements.length; i++) {
            let el = elements[i];
            let value = el.value;
			let text = el.textContent;
            let drel = el.getAttribute('data-rel');
            let li = document.createElement('li');
            let a = document.createElement('a');
            a.setAttribute('href', '#');
            a.setAttribute('data-value', value);
            a.setAttribute('data-rel', drel);
            a.classList.add('option', 'string-option');
            a.textContent = text;
            li.appendChild(a);

			optionsWrap.querySelector('.options ul').appendChild(li);
        };

        const currentValue = currentOption.value;

        optionsWrap.querySelector('.options li a[data-value="'+currentValue+'"]').parentNode.classList.add('active');
	}

    function setSelectedString(select, currentOption){
        const currentText = currentOption.textContent;
        const currentValue = currentOption.value;
        const cdrel = currentOption.getAttribute('data-rel');
        const el = select.nextElementSibling.querySelector('.selected-option');
        el.setAttribute('data-value', currentValue);
        el.setAttribute('data-rel', cdrel);

        el.textContent = currentText;
    }

    // Set up the custom select markup
	function initCustomSelect(){
        let elements = document.querySelectorAll('.anim-select-form select');
        for(let i = 0; i < elements.length; i++) {
            let el = elements[i];
            const select = el;

            // Make sure there is a selected option for this field
            let firstOption = select.querySelector('option');
            firstOption.selected = true;
            firstOption.classList.add('selected');
            const currentOption = as_currentOption(select);

            // Hide the select from view
            select.style.opacity = '0';
            select.style.visiblity = 'hidden';
            select.style.position = 'absolute';

            // Add new markup for custom styling/animation
            let wrapper = document.createElement('div');
            wrapper.classList.add('select-outer');
            select.parentNode.insertBefore(wrapper, select);
            wrapper.appendChild(select);

            select.insertAdjacentHTML('afterend','<div class="animated-select-wrap"><div class="inner clear"></div></div>');
            const animatedWrapper = select.nextElementSibling.querySelector('.inner');

            // Add Navigation buttons
            var arrowUp = '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M13.14 25.09V1.55M1.116 13.407l11.98-11.878 11.773 11.878"/></g></svg>';
            var arrowDown = '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2"><path d="M12.412.337v23.539M24.375 12.02L12.457 23.898.746 12.02"/></g></svg>';

            wrapper = document.createElement('div');
            wrapper.classList.add('select-nav-wrap');

            let prevButton = document.createElement('a');
            prevButton.classList.add('select-nav', 'prev');
            prevButton.setAttribute('title', 'Click for previous option. Hold to scroll faster.');
            prevButton.setAttribute('href','#');
            prevButton.innerHTML = arrowUp;

            let nextButton = document.createElement('a');
            nextButton.classList.add('select-nav', 'next');
            nextButton.setAttribute('title', 'Click for next option. Hold to scroll faster.');
            nextButton.setAttribute('href','#');
            nextButton.innerHTML = arrowDown;

            wrapper.appendChild(prevButton);
            wrapper.appendChild(nextButton);

            animatedWrapper.appendChild(wrapper);

            // For numeric select options, wrap each digit in it's own wrapper for individual digit animation, and add a mobile class if on a mobile device
            if(select.classList.contains('numeric')){
                animatedWrapper.parentNode.classList.add('numeric-select');

                // create the amount of digit wrappers needed for this select
                const digits = getNeededDigits(select);
                for(let i = 0; i < digits; i++){
                    let outerElement = document.createElement('div');
                    outerElement.classList.add('options-wrap', 'numeric-wrap');
                    let innerElement = document.createElement('div');
                    innerElement.classList.add('options-inner');
                    outerElement.appendChild(innerElement);
                    animatedWrapper.appendChild(outerElement);
                }

                // fill each digit wrapper with numbers 0-9
                let optionElements = animatedWrapper.querySelectorAll('.options-wrap');
                for(let i = 0; i < optionElements.length; i++) {
                    let el = optionElements[i];
                    for(let o = 0; o <= 9; o++){
                        let element = document.createElement('div');
                        element.setAttribute('data-value', o);
                        element.textContent = o;
                        element.classList.add('option', 'numeric-option');
                        optionElements[i].querySelector('.options-inner').appendChild(element);
                    }

                    // Set the correct value
                    const val = currentOption.value.charAt(i);
                    animateOptions(el, val);
                };

                // Add mobile class to all numeric selectStringNav
                select.classList.add('mobile');
                animatedWrapper.parentNode.classList.add('mobile');

            }
            // For string option values, create one options wrapper
            else {
                animatedWrapper.parentNode.classList.add('string-select');

                let outerElement = document.createElement('div');
                outerElement.classList.add('options-wrap');

                let innerElement = document.createElement('div');
                innerElement.classList.add('options');

                let heading = document.createElement('h4');
                heading.classList.add('font-weight-500', 'p', 'font-primary');
                heading.textContent = 'Please select an option below';
                innerElement.appendChild(heading);

                let list = document.createElement('ul');
                innerElement.appendChild(list);

                let selectedWrap = document.createElement('div');
                selectedWrap.classList.add('selected-option');

                outerElement.appendChild(innerElement);
                outerElement.appendChild(selectedWrap);
                animatedWrapper.appendChild(outerElement);

                getStringOptions(select, currentOption);
                setSelectedString(select, currentOption);
            }
        };
	}
	initCustomSelect();

    var matches = function(el, selector) {
      return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
    };

    // Navigate the select fields
	// Navigate Numeric selects:
	function selectNumericNav(select, direction) {
		const selectWrap = select.nextElementSibling;
		let currentOption = as_currentOption(select);
		let newOption;

        // Figure out the next option to set as selected
		if (direction === 'prev'){
			if(matches(currentOption, ':first-child')){
				newOption = select.querySelector('option:last-child');
			}
			else {
				newOption = currentOption.previousElementSibling;
			}
		}
		else if (direction === 'next') {
			if(matches(currentOption, ':last-child')){
				newOption = select.querySelector('option:first-child');
			}
			else {
				newOption = currentOption.nextElementSibling;
			}
		} else {
            // This is used for mobile devices, since the user will be selecting from the native select UI
            newOption = currentOption;
            currentOption = select.querySelector('.selected');
            // console.log(newOption);
        }

		// Switch the html select element selected option
		currentOption.selected = "false";
        currentOption.classList.remove('selected');
        newOption.selected = "true";
		newOption.classList.add('selected');

		// Begin setting up animation of visible options
		const currentVal = newOption.value;

		const digitCount = select.nextElementSibling.querySelectorAll('.options-wrap').length;
		const currentLength = currentVal.length;
		let digitDifference = digitCount - currentLength;

        let elements = selectWrap.querySelectorAll('.options-wrap');
        for(let i = 0; i < elements.length; i++) {
            let el = elements[i];
            // If there is a difference in digits, set the unneeded digits to 0, else set them to the value needed.
			if(digitDifference > 0){
				animateOptions(el, 0);
				digitDifference--;
			}
			else {
				const val = currentVal.charAt(i);
				animateOptions(el, val);
			}
        };
	}

    // Navigate String selects:
    function selectStringNav(selected) {
        const selectWrap = selected.closest('.animated-select-wrap');
        const select = selectWrap.previousElementSibling;
        const value = selected.getAttribute('data-value');
        const drel = selected.getAttribute('data-rel');
        const text = selected.textContent;

        // Add active class to selected option in the list viewport
        selectWrap.querySelector('.options .active').classList.remove('active');
        selected.closest('li').classList.add('active');

        // Set the visible select element to the new selected element.
        let el = selected.closest('.options').nextElementSibling;
        el.setAttribute('data-value', value);
        el.setAttribute('data-rel', drel);
        el.textContent = text;

        // Hide the options after selects
        selectWrap.classList.remove('options-visible');

        // Set the html select option to setSelected
        let i = select.selectedIndex;
        let selectedOption = select.options[i];
        selectedOption.selected = "false";
        selectedOption.classList.remove('selected');
		select.querySelector('option[value="'+value+'"]').selected = "false";
		select.querySelector('option[value="'+value+'"]').classList.add('selected');
    }

	// Numeric Select Buttons Clicks: On mousedown, fire navigation imediately. Hold the button for faster navigation
	let selectNavInterval = null;
	let selectNavTimeout = null;

    const numericScrollEvent = function(event){
        const el = this;
        const animatedSelect = el.closest('.animated-select-wrap');
        const select = animatedSelect.previousElementSibling;
        let etype = event.type;

        // For numeric selects, animated scroll the digits
        if(el.closest('.animated-select-wrap').classList.contains('numeric-select')){
            clearInterval(selectNavInterval);
            clearTimeout(selectNavTimeout);

            animatedSelect.classList.add('clicked');

            // determine wether to navigate up or down
            let direction = (el.classList.contains('prev')) ? "prev" : "next";

            // Navigate once imediately on mousedown
            selectNumericNav(select, direction);

            // set a timeout to start an interval after holding the navigation down
            if(etype === 'mousedown') {
                let i = 0;
                selectNavTimeout = setTimeout(function(){
                    animatedSelect.classList.add('hold-slow');

                    selectNavInterval = setInterval(function(){
                        selectNumericNav(select, direction);
                        i++;

                        // After slowly scrolling 5 options, begin fast scrolling
                            if(i === 5){
                                clearInterval(selectNavInterval);
                                if(animatedSelect.classList.contains('hold-slow')){
                                    animatedSelect.classList.remove('hold-slow')
                                }
                                animatedSelect.classList.add('hold-fast');

                                selectNavInterval = setInterval(function(){
                                    selectNumericNav(select, direction);
                                },60);
                            }
                    },200);
                }, 300);
            }
        }
    }

    let selectLinks = document.querySelectorAll('.select-nav-wrap a');
    for(let i = 0; i < selectLinks.length; i++) {
        let el = selectLinks[i];
        el.addEventListener('click', function(e){
    		e.preventDefault();
    	});
    };

    selectLinks = document.querySelectorAll('.select-nav-wrap a');
    for(let i = 0; i < selectLinks.length; i++) {
        let el = selectLinks[i];
        el.addEventListener('mousedown', numericScrollEvent);
        el.addEventListener('keypress', numericScrollEvent);
    };

    // For Numeric selects, clear the intervals/timeouts on mouseup
    document.addEventListener('mouseup', function(){
        if(document.querySelector('.animated-select-wrap.numeric-select') !== null){
    		let select = document.querySelectorAll('.animated-select-wrap.numeric-select');
            for(let i = 0; i < select.length; i++) {
                let el = select[i];
                el.classList.remove('clicked', 'hold-slow', 'hold-fast');
                let links = el.querySelectorAll('.select-nav');
                for(let i = 0; i < links.length; i++) {
                    let el = links[i];
                    el.blur();
                };
            };
            clearInterval(selectNavInterval);
    		clearTimeout(selectNavTimeout);
            let links = document.querySelectorAll('.select-nav-wrap a');
            for(let i = 0; i < links.length; i++) {
                let el = links[i];
                el.blur();
            };
        }
	});

    // String Select Button Clicks:
    selectLinks = document.querySelectorAll('.string-select .select-nav-wrap a, .string-select .selected-option');
    for(let i = 0; i < selectLinks.length; i++) {
        let el = selectLinks[i];
        el.addEventListener('click', function(event){
            const animatedSelect = el.closest('.animated-select-wrap');

            // For numeric selects, animate scroll the digits
            if(animatedSelect.classList.contains('string-select')){
                animatedSelect.classList.add('options-visible');
            }
        });
    };


    selectLinks = document.querySelectorAll('.animated-select-wrap .string-option');
    for(let i = 0; i < selectLinks.length; i++) {
        let el = selectLinks[i];
        el.addEventListener('click', function(e){
            e.preventDefault();
            const el = this;
            el.blur();
            selectStringNav(el);
        });
    };

    // For mobile numeric selects, change the displayed value after the select is changed

    selectLinks = document.querySelectorAll('select.mobile');
    if(selectLinks.length > -1) {
        for(let t = 0; t < selectLinks.length; t++) {
            let el = selectLinks[t];
            el.addEventListener('change', function(){
                selectNumericNav(el);
            });
        };
    }
});
